import { FC } from 'react';

import { Currency, asPercentage, getLocaleSetting, t } from '@onlinepayments/payments-library';

import { AmountType } from '../../enums/AmountType';
import OrderAmount from '../../interfaces/OrderAmount';
import { ofAmountType } from '../../utils/misc';

interface ITaxDetailsProps {
  orderAmounts: OrderAmount[];
  orderCurrency: string;
}

const TaxDetails: FC<ITaxDetailsProps> = ({ orderAmounts, orderCurrency }) => {
  const total = orderAmounts.find(ofAmountType(AmountType.Total));
  const showTaxPercentage = getLocaleSetting().payment.showTaxPercentage;
  const alwaysShowSalesTax = getLocaleSetting().payment.alwaysShowSalesTax;

  const taxDetails = showTaxPercentage
    ? total?.taxDetailsAggregatedOnTypeAndPercentage
    : total?.taxDetailsAggregatedOnType;

  return (
    <>
      {(taxDetails || [])
        .filter(
          ({ taxAmount, taxType }) => (taxType === 'SALES' && alwaysShowSalesTax) || !!taxAmount,
        )
        .map(({ taxType, taxAmount, taxPercentage }) => (
          <li key={taxType} className="flex justify-between items-center my-c-xs">
            {t(`order.tax_type.${taxType}`, undefined, {
              taxPercentage: asPercentage(taxPercentage),
            }) ||
              (taxType === 'VAT' && t('order.vat_label')) ||
              taxType}
            <Currency currency={orderCurrency} amount={taxAmount} />
          </li>
        ))}
    </>
  );
};

export default TaxDetails;
